<template>
    <v-card elevation="1">
        <v-card-title>Selection Procedure Scores</v-card-title>

        <v-alert v-if="showSelectionProcedureNotice" border="left" class="mx-4" colored-border type="info">
            This meet does not apply to the Selection Procedures. The scores shown are simply for informational
            purposes.
        </v-alert>

        <v-tabs v-if="teamQualifiers.length > 1" v-model="selectionTab">
            <v-tab v-for="teamQualifier in teamQualifiers" :key="teamQualifier.key">
                {{ teamQualifier.title }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-if="teamQualifiers.length > 1" v-model="selectionTab">
            <v-tab-item v-for="teamQualifier in teamQualifiers" :key="teamQualifier.key">
                <selection-score-table :team-qualifier="teamQualifier" :result-category="resultCategory" />
            </v-tab-item>
        </v-tabs-items>

        <div v-else>
            <selection-score-table :team-qualifier="teamQualifiers[0]" :result-category="resultCategory" />
        </div>
    </v-card>
</template>

<script>
import Meet from '@/Models/Meet.js';
import SelectionScoreTable from '@/Components/SelectionScoreTable.vue';

export default {
    name: 'SelectionScoreDisplay',

    components: { SelectionScoreTable },

    props: {
        meet: {
            type: Meet,
            required: true,
        },

        teamQualifiers: {
            type: Array,
            required: true,
        },

        resultCategory: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        selectionTab: 0,
        showSelectionProcedureNotice: false,
    }),
};
</script>
